<template>
  <td class="p-0 text-center">
    <input
      type="number"
      step="0.001"
      :disabled="disabled"
      v-model="quantityChild"
      class="app_td_input text-center"
      @change="changeHanler"
      placeholder="monto"
    />
  </td>
</template>
<script>
export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    disabled: { default: false },
    value: {
      default: 0
    }
    // item: {
    //   default: () => ({
    //     product_id: 0,
    //     name: "",
    //     quantity: 0
    //   })
    // }
  },

  data: () => ({
    //
  }),

  computed: {
    quantityChild: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    changeHanler() {
      this.$emit("change");
    }
  }
};
</script>

<style scoped>
.app_td_input {
  display: inline;
  max-width: 6em;
  border-radius: 0px;
  border-width: 2px;
  border-color: transparent;
  border-style: solid;
  padding: 0.2rem;
}

.app_td_input:focus {
  border-width: 2px;
  border-color: var(--primary, blue);

  /* box-shadow: 0px 0px 0px 3px var(--primary, blue); */
}
</style>
